module.exports = __webpack_public_path__ + "static/media/restore.8e8ae78a.ico";